import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Img, DemoAction } from "./shared";

const PHASES = [
  { t: "Gründung", items: ["Wahl der passenden Rechtsform", "Businessplan und Finanzierung", "Anmeldung beim Finanzamt"] },
  { t: "Wachstum", items: ["Laufende Buchhaltung und Lohnverrechnung", "Steuerplanung für Investitionen", "Monatliche Auswertungen"] },
  { t: "Etabliertes Unternehmen", items: ["Jahresabschluss und Bilanz", "Betriebsprüfungen begleiten", "Optimierung der Struktur"] },
  { t: "Übergabe & Nachfolge", items: ["Bewertung des Unternehmens", "Steuerliche Gestaltung der Übergabe", "Begleitung der Nachfolge"] },
];

export default function Steuer({ wide, onCta }) {
  const [open, setOpen] = useState(1);
  return (
    <div className="bg-white text-[#14213D]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <header className="flex items-center justify-between border-b border-[#E3E7EF] px-5 pt-12 pb-4" style={wide ? { paddingTop: 22, paddingLeft: 48, paddingRight: 48 } : undefined}>
        <span className="text-[17px] font-semibold" style={{ fontFamily: "'Source Serif 4 Variable', serif" }}>Huber & Lechner</span>
        <span className="text-[11px] uppercase tracking-[0.16em] text-[#4A5A7A]">Steuerberatung</span>
      </header>
      <section className={wide ? "grid grid-cols-[1.1fr_1fr] gap-12 bg-[#14213D] px-12 py-16 text-white" : "bg-[#14213D] px-5 py-10 text-white"}>
        <div>
          <p className="text-[12px] uppercase tracking-[0.2em] text-[#A9B8D6]">Für Unternehmen jeder Phase</p>
          <h1 className={`mt-3 leading-[1.1] ${wide ? "text-[48px]" : "text-[32px]"}`} style={{ fontFamily: "'Source Serif 4 Variable', serif" }}>Klarheit in Zahlen.<br />Sicherheit in Entscheidungen.</h1>
          <p className="mt-4 text-[14px] leading-relaxed text-[#D5DCEA]">Persönliche Steuerberatung mit klaren Abläufen und festen Ansprechpartnern.</p>
        </div>
        <div className={wide ? "h-[300px]" : "mt-6 h-[180px]"}><Img k="office1" alt="Besprechung" /></div>
      </section>
      <section className={wide ? "px-12 py-14" : "px-5 py-8"}>
        <h2 className="text-[24px]" style={{ fontFamily: "'Source Serif 4 Variable', serif" }}>Leistungen nach Unternehmensphase</h2>
        <div className="mt-5 divide-y divide-[#E3E7EF] border-y border-[#E3E7EF]">
          {PHASES.map((p, i) => (
            <div key={p.t}>
              <button type="button" data-noswipe aria-expanded={open === i} onClick={() => setOpen(open === i ? -1 : i)} className="flex w-full items-center justify-between py-4 text-left">
                <span className="flex items-baseline gap-3"><span className="text-[12px] text-[#4A5A7A]">0{i + 1}</span><span className="text-[16px] font-semibold">{p.t}</span></span>
                <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && (
                <ul className="space-y-2 pb-4 pl-8 text-[14px] text-[#33415C]">
                  {p.items.map((x) => <li key={x} className="flex gap-2"><span className="mt-2 h-1 w-3 bg-[#14213D]" />{x}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
        <DemoAction label="Erstberatung vereinbaren" onCta={onCta} className="mt-6 bg-[#14213D] px-6 py-3.5 text-[14px] font-semibold text-white" />
      </section>
    </div>
  );
}
